module.exports = __webpack_public_path__ + "static/img/invite_img.d2b6f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite_img.png
// module id = YG9g
// module chunks = 0